// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"9bc9322f","453":"84f30c3e"}[chunkId] + ".chunk.js";
};